import graph1 from "./../resources/images/info/grapph_1.png";
import logoLittle from "./../resources/images/main/logo_little.svg";
import alaska from "./../resources/images/info/alaska.svg";
import men from "./../resources/images/connecting/men.jpg";
import women from "./../resources/images/connecting/women.jpg";
import bg1 from "./../resources/images/loading/loader_1_d.png";
import bg2 from "./../resources/images/loading/loader_2_d.png";
import bg3 from "./../resources/images/loading/loader_3_d.png";
import bg4 from "./../resources/images/loading/loader_4_d.png";
import bg5 from "./../resources/images/loading/loader_5_d.png";
import bg6 from "./../resources/images/loading/loader_6_d.png";
import bg7 from "./../resources/images/loading/loader_7_d.png";
import bg8 from "./../resources/images/loading/loader_8_d.png";
import bg9 from "./../resources/images/loading/loader_9_d.png";
import bg10 from "./../resources/images/loading/loader_10_d.png";
import bg11 from "./../resources/images/loading/loader_11_d.png";

// import bg1M from "./../resources/images/loading/loading_1.png";
// import bg2M from "./../resources/images/loading/loading_2.png";
// import bg3M from "./../resources/images/loading/loading_3.png";
// import bg4M from "./../resources/images/loading/loading_4.png";
// import bg5M from "./../resources/images/loading/loading_5.png";
// import bg6M from "./../resources/images/loading/loading_6.png";
// import bg7M from "./../resources/images/loading/loading_7.png";

import bg1M from "./../resources/images/loading/loading_1.jpg";
import bg2M from "./../resources/images/loading/loading_2.jpg";
import bg3M from "./../resources/images/loading/loading_3.jpg";
import bg4M from "./../resources/images/loading/loading_4.jpg";
import bg5M from "./../resources/images/loading/loading_5.jpg";
import bg6M from "./../resources/images/loading/loading_6.jpg";
import bg7M from "./../resources/images/loading/loading_7.jpg";

import bg8M from "./../resources/images/loading/loading_8.png";
import bg9M from "./../resources/images/loading/loading_9.png";
import bg10M from "./../resources/images/loading/loading_10.png";
import bg11M from "./../resources/images/loading/loading_11.png";

import ans1 from "./../resources/images/questions/ans_1.png";
import ans2 from "./../resources/images/questions/ans_2.png";
import ans3 from "./../resources/images/questions/ans_3.png";
import ans4 from "./../resources/images/questions/ans_4.png";
import ans5 from "./../resources/images/questions/ans_5.png";
import ans6 from "./../resources/images/questions/ans_6.png";
import ans7 from "./../resources/images/questions/ans_7.png";
import ans8 from "./../resources/images/questions/ans_8.png";

import graph from "./../resources/images/connecting/graph.png";
import graph2 from "./../resources/images/connecting/graph_2.png";

import stars1 from "./../resources/images/subscription/stars_1.svg";
import stars2 from "./../resources/images/subscription/stars_2.svg";
import stars3 from "./../resources/images/subscription/stars_3.svg";
import stars4 from "./../resources/images/subscription/stars_4.svg";
import stars5 from "./../resources/images/subscription/stars_5.svg";
import avatar1 from "./../resources/images/subscription/avatar_1.png";
import avatar2 from "./../resources/images/subscription/avatar_2.png";
import avatar3 from "./../resources/images/subscription/avatar_3.png";

import prePaywall1 from "./../resources/images/prePaywall/course_1.png";
import prePaywall2 from "./../resources/images/prePaywall/course_2.png";
import prePaywall3 from "./../resources/images/prePaywall/course_3.png";
import prePaywall4 from "./../resources/images/prePaywall/course_4.png";
import prePaywall5 from "./../resources/images/prePaywall/course_5.png";
import prePaywall6 from "./../resources/images/prePaywall/course_6.png";
import prePaywall7 from "./../resources/images/prePaywall/course_7.png";
import prePaywall8 from "./../resources/images/prePaywall/course_8.png";
import prePaywall9 from "./../resources/images/prePaywall/course_9.png";
import prePaywall10 from "./../resources/images/prePaywall/course_10.png";
import prePaywall11 from "./../resources/images/prePaywall/course_11.png";

import prePaywallAudioBird from "./../resources/images/prePaywall/birds.png";
import prePaywallAudioThunder from "./../resources/images/prePaywall/thunderstorm.png";
import prePaywallAudioForest from "./../resources/images/prePaywall/forest.png";
import prePaywallAudioMeditation from "./../resources/images/prePaywall/meditation.png";
import prePaywallAudioRain from "./../resources/images/prePaywall/rain.png";
import prePaywallAudioNoise from "./../resources/images/prePaywall/white_noise.png";
import prePaywallAudioOcean from "./../resources/images/prePaywall/ocean.png";
import prePaywallAudioReligion from "./../resources/images/prePaywall/religion.png";

import inLateafternoonAudio from "./../resources/audio/In Late Afternoon - 40s sample.mp3";
import inLateStoryImage from "./../resources/audio/previewImages/inLateStoryImage.png";

import preSlide1 from "./../resources/images/prePaywall/slide_1.png";
import preSlide2 from "./../resources/images/prePaywall/slide_2.png";
import preSlide3 from "./../resources/images/prePaywall/slide_3.png";
import preSlide4 from "./../resources/images/prePaywall/slide_4.png";

// audio imports
import birdsAudio from "./../resources/audio/JSE_Forest Birds - 30s sample.mp3";
import birdsPreview from "./../resources/audio/previewImages/forest_birds.png";

import rainAudio from "./../resources/audio/1 Light Rain - 30s sample.mp3";
import rainPreview from "./../resources/audio/previewImages/light_rain.png";

import thunderstormAudio from "./../resources/audio/1_Thunderstorm Soundscape - 30s sample.mp3";
import thunderstormPreview from "./../resources/audio/previewImages/thunderstorm.png";

import whiteNoiseAudio from "./../resources/audio/02_White Noise - 16s sample.mp3";
import whiteNoisePreview from "./../resources/audio/previewImages/white_noise.png";

import oceanAudio from "./../resources/audio/9_Ocean Waves - 30s sample.mp3";
import oceanPreview from "./../resources/audio/previewImages/ocean_waves.png";

import forestAudio from "./../resources/audio/7_Forest Brook - 30s sample.mp3";
import forestPreview from "./../resources/audio/previewImages/forest_brook.png";

import meditationAudio from "./../resources/audio/Mind Relaxation Meditation - 30s sample.mp3";
import meditationPreview from "./../resources/audio/previewImages/mind_relaxation.png";

import religionAudio from "./../resources/audio/Gods Blessings - 35s sample.mp3";
import religionPreview from "./../resources/audio/previewImages/angels_blessing.png";

import prelandIcon1 from "./../resources/images/preLand/icon_1.png";
import prelandIcon2 from "./../resources/images/preLand/icon_2.png";
import prelandIcon3 from "./../resources/images/preLand/icon_3.png";
import prelandIcon4 from "./../resources/images/preLand/icon_4.png";
import prelandIcon5 from "./../resources/images/preLand/icon_5.png";
import prelandIcon6 from "./../resources/images/preLand/icon_6.png";
import prelandIcon7 from "./../resources/images/preLand/icon_7.png";
import prelandIcon8 from "./../resources/images/preLand/icon_8.png";

import aarpIcon from "./../resources/images/icons/aarp.svg";

import { greenColor, orangeColor } from "./colors";
import { addTimeFunction } from "../utils/helper";
import moment from "moment";
import noIcon from "../resources/images/paywall/no_i.svg";
import yesIcon from "../resources/images/paywall/yes.svg";

import whatYourGetItem1 from "./../resources/images/offer/whatYourGetItem1.png"
import whatYourGetItem2 from "./../resources/images/offer/whatYourGetItem2.png"
import whatYourGetItem3 from "./../resources/images/offer/whatYourGetItem3.png"
import whatYourGetItem4 from "./../resources/images/offer/whatYourGetItem4.png"
import whatYourGetItem5 from "./../resources/images/offer/whatYourGetItem5.png"
import whatYourGetItem6 from "./../resources/images/offer/whatYourGetItem6.png"
import whatYourGetItem7 from "./../resources/images/offer/whatYourGetItem7.png"
import whatYourGetItem8 from "./../resources/images/offer/whatYourGetItem8.png"

export const TERMS_LINK = "https://gojourney.app/terms-of-use/";
export const PRIVACY_LINK = "https://gojourney.app/privacy-policy/";

export const STRIPE_PUBLIC_KEY =
  "pk_live_51JywfdKX3MqBhuCUZ7xjBXieNqibW5O6FFuyeQtiZnfgVMILHWz1E3y3DTSZmrIEG5pvrU6HMdGdPAH0O7eY3S110089BKA8vQ";
// "pk_test_51JywfdKX3MqBhuCUQP4GpmtEGsHRpKqjzK4BOEvJTLYgGZRn21zSPeRhmiBKjcKs8aBIv4rhH8oPls61ZwLeDKah00b9eKpBdh";

export const liveProduct = "price_1KbPrAKX3MqBhuCUeCHumfcl";
export const testProduct = "price_1KaLCLKX3MqBhuCUy7rcKbwi";
export const ONBOARDING_ID = "onboarding";
export const ONBOARDING_ID_GOOGLE = "none";
export const ONBOARDING_ID_FB = "none";
export const LANDING_ID = "sleep-problems";
export const LANDING_ID_GOOGLE = "sleep-problems-google";
export const LANDING_ID_FB = "sleep-problems-fb";

export const pre_landing_fb_link = "https://gojourney.app/";
export const pre_landing_google_link = "https://apps.apple.com/us/app/journey-digital-sleep-coach/id1590102815/";

export const VERSION = "0.3";
export const STORE_URL = "https://apps.apple.com/app/id1590102815?mt=8";

export const scrollHeight = 250;
export const timeRemaining = 900;
export const LOADER_ANIMATION_TIME = 5500;

export const SE_CLIENT_HEIGHT = 668;

// PAYMENT FORM DATA
// END PAYMENT FORM DATA

// EMAIL PAYWALL DATA
export const DARK_THEME_EMAIL_PAYWALL_KEY = "30_1month15-1year70_dark";
export const LIGHT_THEME_EMAIL_PAYWALL_KEY = "30_1month15-1year70_light";

export const EMAIL_PAYWALL_THEME_OBJ = {
  [DARK_THEME_EMAIL_PAYWALL_KEY]: "dark",
  [LIGHT_THEME_EMAIL_PAYWALL_KEY]: "light",
};

export const email_paywall_50_list = [
  "Unique personalized sleep program tailored to your needs (based on your age and specifications)",
  "Curated content from leading Sleep therapists from ",
  "Exclusive stories to fall asleep faster",
  "Original music for sleep, relaxation and wake-up",
  "Just 15 minutes per day to see noticeable results",
  "Daily tips for a healthy lifestyle",
];

export const pre_paywall_list = [
  "Unique personalized sleep program tailored to your needs (based on your age and specifications)",
  "Curated content from leading sleep therapists",
  "Exclusive sleep stories to fall asleep faster",
  "500+ meditations, sleep stories, music, & nature sounds (new content added every month)",
  "Original music for sleep, relaxation and wake-up",
  "Just 15 minutes per day to see noticeable results",
  "Daily tips for a healthy lifestyle",
];

export const EMAILS_PLANS = [
  {
    id: 0,
    index: 0,
    title: "12-Month Plan",
    perWeek: 1.35,
    fullSum: 99.99,
    finalSum: 69.99,
    product: process.env.REACT_APP_PRODUCT_69,
  },
  {
    id: 1,
    index: 1,
    title: "1-Month Plan",
    perWeek: 3.75,
    fullSum: 21.44,
    finalSum: 14.99,
    product: process.env.REACT_APP_PRODUCT_14,
  },
];
// END EMAIL PAYWALL DATA

// PRELAND DATA
export const secondItems = [
  {
    icon: noIcon,
    text: "Appointments or Waitlists",
  },
  {
    icon: noIcon,
    text: "Costly Supplements ",
  },
  {
    icon: noIcon,
    text: "Long-term treatment",
  },
  {
    icon: noIcon,
    text: "Restrictions ",
  },
  {
    icon: yesIcon,
    text: "Restful deep sleep all night long",
  },
];

export const pre_land_list = [
  {
    id: 0,
    text: {
      __html:
        "<span style='color: white; font-weight: 600'> 7 out of 10 </span> people reported improved sleep",
    },
  },
  {
    id: 1,
    text: {
      __html:
        "<span style='color: white; font-weight: 600'>64%</span> of people fall asleep in <span style='color: white; font-weight: 600'>14 minutes</span>",
    },
  },
  {
    id: 2,
    text: {
      __html:
        "<span style='color: white; font-weight: 600'>9 out of 10</span> people feel more energetic in the morning",
    },
  },
  {
    id: 3,
    text: {
      __html:
        "Users report reduced time awake at night by up to <span style='color: white; font-weight: 600'>60%</span>",
    },
  },
];

export const pre_land_list_second = [
  {
    id: 0,
    text: {
      __html: "Unique personalized sleep program tailored to your needs",
    },
  },
  {
    id: 1,
    text: {
      __html: "Curated content from leading sleep therapists",
    },
  },
  {
    id: 2,
    text: {
      __html: "Exclusive sleep stories to fall asleep faster",
    },
  },
  {
    id: 3,
    text: {
      __html:
        "500+ meditations, sleep stories, music & nature sounds (new content every month)",
    },
  },
  {
    id: 4,
    text: {
      __html: "Original music for sleep, relaxation and wake-up",
    },
  },
  {
    id: 5,
    text: {
      __html: "Just 15 minutes per day to see noticeable results",
    },
  },
  {
    id: 6,
    text: {
      __html: "Daily tips for a healthy lifestyle",
    },
  },
];

export const preland_items = [
  {
    text: "35.6% of adults over 65 in the U.S. sleep on average less than seven hours per night.",
    id: 0,
    messageText:
      "Short Sleep Duration (<7 Hours) by Sex, Age, and Race/Ethnicity — Behavioral Risk Factor Surveillance System, United States, 2014",
  },
  {
    text: "Adults who were short sleepers (less than 7 hours per 24-hour period) were more likely to report 10 chronic health conditions compared to those who got enough sleep (7 or more hours per 24-hour period).",
    id: 1,
    messageText:
      "Short Sleep Duration (<7 Hours) by Sex, Age, and Race/Ethnicity — Behavioral Risk Factor Surveillance System, United States, 2014",
  },
  {
    text: "Between 30% and 48% of older adults suffer from insomnia.",
    id: 2,
    messageText:
      "Dhaval Patel, MD, Joel Steinberg, MD, and Pragnesh Patel, MD, Journal of Clinical Sleep Medicine, 2018 Jun 15; 14(6): 1017–1024.",
  },
];

export const pre_land_top_icon_list = [
  {
    icon: prelandIcon1,
    text: "Tailor-made sleep course",
    id: 0,
  },
  {
    icon: prelandIcon2,
    text: "15 minutes of personal Sleep Plan per day",
    id: 1,
  },
  {
    icon: prelandIcon3,
    text: "CBT-based method",
    id: 2,
  },
  {
    icon: prelandIcon4,
    text: "Science-backed digital program",
    id: 3,
  },
];

export const pre_land_top_icon_list_second = [
  {
    icon: prelandIcon5,
    text: "Build healthy sleep habits",
    id: 0,
  },
  {
    icon: prelandIcon6,
    text: "Fall asleep faster",
    id: 1,
  },
  {
    icon: prelandIcon7,
    text: "Wake up refreshed",
    id: 2,
  },
  {
    icon: prelandIcon8,
    text: "Reduce time awake at night",
    id: 3,
  },
];

export const pre_land_spoilers = [
  {
    id: 0,
    title: "What is sound therapy and how does it work?",
    text: [
      "Sound Therapy uses sound, music and special instruments played in therapeutic ways, combined with deep self-reflection techniques to improve health and wellbeing.",
    ],
  },
  {
    id: 1,
    title: "Can CBT help with sleep?",
    text: [
      "Cognitive behavioral therapy for insomnia, sometimes called CBT-I, is an effective treatment for chronic sleep problems and is usually recommended as the first line of treatment.",
      "CBT-I is the only scientifically proven, non-drug insomnia treatment. CBT-I is recommended by Harvard Medical School, Mayo Clinic, WebMD, National Sleep Foundation and the National Institute of Health.",
      "Cognitive behavioral therapy for insomnia is a structured program that helps you identify and replace thoughts and behaviors that cause or worsen sleep problems with habits that promote sound sleep. Unlike sleeping pills, CBT-I helps you overcome the underlying causes of your sleep problems.",
      "CBT-I techniques: stimulus control therapy, sleep restriction, sleep hygiene, sleep environment improvement, relaxation training, remaining passively awake.",
    ],
  },
  {
    id: 2,
    title: "Are mobile apps backed up by CBT effective for sleep problems?",
    text: [
      "Studies show that CBT-I delivered digitally through mobile phone apps is effective in treating insomnia and improving sleep habits.",
    ],
    science:
      "A randomized, placebo-controlled trial of online cognitive behavioral therapy for chronic insomnia disorder delivered via an automated media-rich web application. Espie, C. A., Kyle, S. D., Williams, C., Ong, J. C., Douglas, N. J., Hames, P., & Brown, J. S. (2012).  Sleep, 35(6), 769-781.",
  },
  {
    id: 3,
    title: "How long does CBT take to work for sleep?",
    text: [
      "At the end of 6 weeks, your sleep will be improved and you will have the knowledge to continue working on your success",
    ],
  },
  {
    id: 4,
    title: "Does Journey have a subscription and a free trial period?",
    dependingKey: "paidTrialEnabled",
    dependText: [
      `Your 7-day trial lasts until ${moment()
        .add(7, "days")
        .format("MMMM DD, YYYY")}. You may cancel at any time before ${moment()
        .add(7, "days")
        .format(
          "MMMM DD, YYYY"
        )}, and you will not be charged the annual membership fee. If you don’t cancel, Journey will automatically continue your membership at the end of your 7-day trial and charge the membership fee on a yearly basis until your cancel. You can cancel your subscriptions anytime on your Subscription Management page. We also offer a money-back guarantee for 30 days."`,
      `At Journey we're giving you the opportunity to try our Premium subscription for 7 days free of charge so that you can fully experience the content and premium features and start improving your sleep. Your free 7-day trial lasts until ${moment()
        .add(7, "days")
        .format("MMMM DD, YYYY")}. You may cancel at any time before ${moment()
        .add(7, "days")
        .format(
          "MMMM DD, YYYY"
        )}, and you will not be charged the annual membership fee. If you don’t cancel, Journey will automatically continue your membership at the end of your 7-day trial and charge the membership fee on a yearly basis until your cancel. You can cancel your subscriptions anytime on your Subscription Management page. We also offer a money-back guarantee for 30 days.`,
    ],
  },
];
// END PRELAND DATA

// PREPAYWALL DATA
export const prePaywallData = [
  {
    id: 0,
    text: "Tailor-made sleep course",
  },
  {
    id: 1,
    text: "Sleep stories and sounds based on your preferences",
  },
  {
    id: 2,
    text: "Personal digital sleep coach",
  },
  {
    id: 3,
    text: "Daily sleep insights",
  },
  {
    id: 4,
    text: "Morning and evening check-ins",
  },
  {
    id: 5,
    text: "Exercises / Audio for bedtime",
  },
];

export const prePaywallCourseFirstItems = [
  {
    id: 0,
    day: 1,
    title: "CBT Method Explained",
    img: prePaywall1,
  },
  {
    id: 1,
    day: 2,
    title: "Sleep Phases and Stages",
    img: prePaywall2,
  },
  {
    id: 2,
    day: 3,
    title: "Natural Alarm-Clocks",
    img: prePaywall3,
  },
];

// if first point choose
export const firstPointChoose = [
  {
    id: 3,
    day: 4,
    title: "Activities Before Sleep: Do’s and Don'ts",
    img: prePaywall5,
  },
  {
    id: 4,
    day: 5,
    title: "Sleeping Pills and Melatonin: Are They Bad for You?",
    img: prePaywall6,
  },
  {
    id: 5,
    day: 6,
    title: "Action Plan for a Relaxing Bedroom",
    img: prePaywall10,
  },
  {
    id: 6,
    day: 7,
    title: "How to Keep Yourself Motivated?",
    img: prePaywall4,
  },
];

export const prePaywallSlides = [
  {
    img: preSlide1,
    id: 0,
  },
  {
    img: preSlide2,
    id: 1,
  },
  {
    img: preSlide3,
    id: 2,
  },
];

// if second point choose
export const secondPointChoose = [
  {
    id: 3,
    day: 4,
    title: "How to Fight Night Awakenings",
    img: prePaywall7,
  },
  {
    id: 4,
    day: 5,
    title: "Activities Before Sleep: Do’s and Don'ts",
    img: prePaywall5,
  },
  {
    id: 5,
    day: 6,
    title: "Worry Time Technique",
    img: prePaywall8,
  },
  {
    id: 6,
    day: 7,
    title: "How to Keep Yourself Motivated?",
    img: prePaywall4,
  },
];

// if third point choose
export const thirdPointChoose = [
  {
    id: 3,
    day: 4,
    title: "Getting Up Easily",
    img: prePaywall9,
  },
  {
    id: 4,
    day: 5,
    title: "Action Plan for a Relaxing Bedroom",
    img: prePaywall10,
  },
  {
    id: 5,
    day: 6,
    title: "Worry Time Technique",
    img: prePaywall8,
  },
  {
    id: 6,
    day: 7,
    title: "How to Keep Yourself Motivated?",
    img: prePaywall4,
  },
];

// if fourth point choose
export const fourthPointChoose = [
  {
    id: 3,
    day: 4,
    title: "Action Plan for a Relaxing Bedroom",
    img: prePaywall10,
  },
  {
    id: 4,
    day: 5,
    title: "Simple Life Hacks for Relaxation",
    img: prePaywall11,
  },
  {
    id: 5,
    day: 6,
    title: "Worry Time Technique",
    img: prePaywall8,
  },
  {
    id: 6,
    day: 7,
    title: "How to Keep Yourself Motivated?",
    img: prePaywall4,
  },
];

export const prePaywallPoints = [
  firstPointChoose,
  secondPointChoose,
  thirdPointChoose,
  fourthPointChoose,
];

// if two points choose additional point
export const twoPointsChooseAdditional = [
  {
    id: 5,
    day: 6,
    title: "Diet for a Good Sleep",
    img: prePaywall8,
  },
  {
    id: 6,
    day: 7,
    title: "How to Keep Yourself Motivated?",
    img: prePaywall4,
  },
];

// if four points choose
export const allPointsChoose = [
  {
    id: 3,
    day: 4,
    title: "Activities Before Sleep: Do’s and Don'ts",
    img: prePaywall5,
  },
  {
    id: 4,
    day: 5,
    title: "How to Fight Night Awakenings",
    img: prePaywall7,
  },
  {
    id: 5,
    day: 6,
    title: "Getting Up Easily",
    img: prePaywall9,
  },
  {
    id: 6,
    day: 7,
    title: "How to Keep Yourself Motivated?",
    img: prePaywall4,
  },
];

export const audioArray = [
  {
    src: birdsAudio,
    img: birdsPreview,
    id: 0,
    title: "Nature",
    name: "Forest Birds",
    shortName: "Birds",
    shortImg: prePaywallAudioBird,
  },
  {
    src: rainAudio,
    img: rainPreview,
    id: 1,
    title: "Nature",
    name: "Light Rain",
    shortName: "Rain",
    shortImg: prePaywallAudioRain,
  },
  {
    src: thunderstormAudio,
    img: thunderstormPreview,
    id: 2,
    title: "Nature",
    name: "Thunderstorm",
    shortName: "Thunderstorm",
    shortImg: prePaywallAudioThunder,
  },
  {
    src: whiteNoiseAudio,
    img: whiteNoisePreview,
    id: 3,
    title: "Nature",
    name: "White Noise",
    shortName: "White Noise",
    shortImg: prePaywallAudioNoise,
  },
  {
    src: oceanAudio,
    img: oceanPreview,
    id: 4,
    title: "Nature",
    name: "Ocean",
    shortName: "Ocean",
    shortImg: prePaywallAudioOcean,
  },
  {
    src: forestAudio,
    img: forestPreview,
    id: 5,
    title: "Nature",
    name: "Forest",
    shortName: "Forest",
    shortImg: prePaywallAudioForest,
  },
  {
    src: meditationAudio,
    img: meditationPreview,
    id: 6,
    title: "MEDITATION",
    name: "Mind Relaxation",
    shortName: "Meditation",
    shortImg: prePaywallAudioMeditation,
  },
  {
    src: religionAudio,
    img: religionPreview,
    id: 7,
    title: "MEDITATION",
    name: "Gods Blessing",
    shortName: "Religion",
    shortImg: prePaywallAudioReligion,
  },
];

export const mainAnswers = [
  {
    text: "Fall asleep faster",
    value: 0,
  },
  {
    text: "Stay asleep",
    value: 1,
  },
  {
    text: "Wake up refreshed",
    value: 2,
  },
  {
    text: "Reduce stress",
    value: 3,
  },
];

export const samplesArray = [
  {
    audio: birdsAudio,
    img: birdsPreview,
  },
  {
    audio: rainAudio,
    img: rainPreview,
  },
  {
    audio: thunderstormAudio,
    img: thunderstormPreview,
  },
  {
    audio: whiteNoiseAudio,
    img: whiteNoiseAudio,
  },
  {
    audio: oceanAudio,
    img: oceanPreview,
  },
  {
    audio: forestAudio,
    img: forestPreview,
  },
  {
    audio: meditationAudio,
    img: meditationPreview,
  },
  {
    audio: religionAudio,
    img: religionPreview,
  },
];
// END PREPAYWALL DATA

// PAYWALL DATA
// paywall fourth data
export const paywallFourthlData = [
  {
    id: 0,
    text: "One-time non-recurring payment.",
  },
  {
    id: 1,
    text: "On each purchase we donate $3 to",
    icon: aarpIcon,
  },
];

export const fourth_paywall_timeline_items = [
  {
    id: 0,
    title: "Today: Get Instant Access",
    text: {
      __html:
        "Start with full access to your personal Sleep Plan and all premium content.",
    },
  },
  {
    id: 1,
    title: "Day 5: Trial Reminder",
    text: {
      __html: "Get a reminder about when your trial ends.",
    },
  },
  {
    id: 2,
    title: "Day 7: Trial Ends",
    text: {
      __html: `Your 7-day trial last until <b>${moment()
        .add(7, "days")
        .format(
          "HH:MM A, MMMM DD, YYYY"
        )}.</b> You may cancel at any time before.`,
    },
  },
];

export const paywall_fourth_info_block_top = {
  title: "Why do I have to add payment method?",
  text: {
    __html:
      "In order to keep Journey a safe and sustainable app, we require new members to verify their identity with a payment method. Don’t worry. If you cancel anytime before the end of the 7-day free trial, you won’t be charged.",
  },
};

export const paywall_fourth_info_block_bottom = {
  title: "How my free trial works?",
  text: {
    __html: `<span style='color: #050237; font-weight: 600 ' >Your 7-day free trial last until ${moment()
      .add(7, "days")
      .format(
        "HH:MM A, MMMM DD, YYYY"
      )}.</span> You may cancel at any time before ${moment()
      .add(7, "days")
      .format(
        "HH:MM A, MMMM DD, YYYY"
      )}, and you will not be charged. If you don’t cancel, Journey will automatically continue your membership at the end of your 7-day trial and charge the yearly membership fee ($19.99). This is <span style='color: #050237; font-weight: 600 '>one-time non-recurring payment,</span> you will not be automatically charged at the end of your yearly membership. You don't have to worry about unsubscribing. There are no refunds or credits for partial years. You can cancel your subscriptions anytime on your Subscription Management page.`,
  },
};

export const PAYWALL_FIRST = 1;
export const PAYWALL_SECOND = 2;
export const PAYWALL_THIRD = 3;
export const PAYWALL_FOURTH = 4;

export const comments = [
  {
    name: "Sunnya2519",
    img: stars1,
    avatar: avatar1,
    count: 4.8,
    text: "I feel like “Journey” cares about me. It helps me not think at night.",
  },
  {
    name: "nmmmiranda",
    img: stars2,
    avatar: avatar2,
    count: 5.0,
    text: "Thank you I really appreciate it. It really helps me rest at night.",
  },
  {
    name: "Weeza1961",
    img: stars3,
    avatar: avatar3,
    count: 4.6,
    text: "I really enjoyed this app. It helped me sleep.",
  },
];

export const commentsNew = [
  {
    name: "Sunnya",
    age: 68,
    place: "California, US",
    img: stars5,
    avatar: avatar3,
    text: {
      __html:
        "I feel like \"Journey\" cares about me. I love that it chats with me, even tho my answers are already there for me. I feel like I'm not alone. It helps me not think at night. I haven't heard one story yet, to the end.</br>I’m out before they finish. Thank you.",
    },
  },
  {
    name: "Robin",
    age: 63,
    place: "Florida, US",
    img: stars5,
    avatar: avatar1,
    text: {
      __html:
        "It has a feel of “nurturing” like your all-wise mother telling you you need to go to bed BECAUSE you need to <br> go to bed and you know it but need someone to urge you to do what you need to. That was the feeling I was getting from the app. I would probably AFFECTIONATELY nickname the app “Mom” accordingly.",
    },
  },
  {
    name: "Susan",
    age: 62,
    place: "North Carolina, US",
    img: stars4,
    avatar: avatar2,
    text: {
      __html:
        "I was skeptical at 1st. Like, can this really help you? But it did. I could tell it significantly helped me. I felt like I had better sleep and I got to bed faster than I normally do. Usually I toss and think, but those steps getting you ready and then having the different kinds of sounds really made a difference.",
    },
  },
];
// END PAYWALL DATA

// 12 weeks product
export const sumObj = {
  startSum: 59.99,
  discountSum: 29.99,
  finalSum: 29.99,
  discountText: "50% Introductory offer discount",
  bottomText: "You just saved $29.99 (50% off)",
  finishTime: addTimeFunction(1, "quarter"),
  period: "quarterly",
  periodText: "quarter",
};

// monthly product
export const sumObjMonthly = {
  startSum: 21.44,
  discountSum: 6.43,
  finalSum: 14.99,
  discountText: "30% Introductory offer discount",
  bottomText: "You just saved $6.43 (30% off)",
  finishTime: addTimeFunction(1, "month"),
  period: "monthly",
  periodText: "month",
};

// yearly product
export const sumObjYearly = {
  startSum: 99.99,
  discountSum: "29.99",
  finalSum: 69.99,
  discountText: "30% Introductory offer discount",
  bottomText: "You just saved $29.99 (30% off)",
  finishTime: addTimeFunction(1, "year"),
  period: "yearly",
  periodText: "year",
};

// SUBSCRIPTION DATA
export const subscribeList = [
  "Instant results after first try",
  "Engaging and effective",
  "Decompress and relax quickly",
  "Calm racing mind before sleep",
];
// END SUBSCRIPTION DATA

// PAGES DATA
export const types = {
  questionSingle: 1,
  infoNext: 2,
  infoLoading: 3,
  questionMulti: 4,
  infoFast: 5,
  infoImgComment: 6,
  loader: 7,
  questionImg: 8,
  analyze: 9,
  email: 10,
  cost: 11,
};
// END PAGES DATA

// PROGRESS BAR
export const questionsBlocks = [
  {
    title: "About You",
  },
  {
    title: "Sleep & Activity",
  },
  {
    title: "Personalization",
  },
];
// END PROGRESSBAR

// PAGES
export const data = [
  {
    route: "/onboarding/aboutYouGuided",
    type: 1,
    data: {
      eventFillName: "guided sleep stories",
      nextRoute: "/onboarding/aboutYouD1",
      questionNum: 1,
      totalQuestion: 5,
      questionBlock: 0,
      question: "Have you heard about guided sleep stories?",
      answers: [
        {
          text: "I’m new to it",
          value: 0,
        },
        {
          text: "Not much, but I’m curious",
          value: 1,
        },
        {
          text: "Yes, I’m an expert",
          value: 2,
        },
      ],
    },
  },
  {
    route: "/onboarding/aboutYouD1",
    type: 2,
    data: {
      eventFillName: "perfect",
      audioEventFillName: "sleep_story_play",
      nextRoute: "/onboarding/AboutYouGender",
      questionNum: 2,
      totalQuestion: 5,
      questionBlock: 0,
      title: "Perfect",
      remoteConfigKeyDepending: "sleepStoryEnabled",
      dependOn: {
        title: "/onboarding/aboutYouGuided",
        depend: "value",
      },
      textHtml: [
        {
          __html:
            "We’ve built our plan with beginners in mind. Let’s learn more together! <br/><br/> Sleep stories are sleep-oriented audio tracks that are specifically designed to help you fall asleep.",
        },
        {
          __html:
            "We’ve built our plan with avid learners in mind. Let’s reward your curiosity! <br/><br/> Sleep stories are sleep-oriented audio tracks that are specifically designed to help you fall asleep.",
        },
        {
          __html:
            "You should know what we’re all about. Let’s see if we can show you something new!",
        },
      ],
      audioArray: [
        {
          src: inLateafternoonAudio,
          img: inLateStoryImage,
          id: 0,
          title: "Story",
          name: "In Late Afternoon",
        },
      ],
    },
  },
  {
    route: "/onboarding/AboutYouGender",
    type: 1,
    data: {
      eventFillName: "gender",
      nextRoute: "/onboarding/AboutYouAge",
      questionNum: 2,
      totalQuestion: 5,
      questionBlock: 0,
      question: "What gender do you identify with?",
      answers: [
        {
          text: "Female",
          value: 0,
        },
        {
          text: "Male",
          value: 1,
        },
        {
          text: "Non-binary",
          value: 2,
        },
        {
          text: "Prefer not to say",
          value: 3,
        },
      ],
    },
  },
  {
    route: "/onboarding/AboutYouAge",
    type: 1,
    data: {
      eventFillName: "age",
      advEventProperty: "quiz_age",
      nextRoute: "/onboarding/AboutYouRoutine",
      questionNum: 3,
      totalQuestion: 5,
      questionBlock: 0,
      question: "What’s your age?",
      answers: [
        {
          text: "20s",
          value: 0,
        },
        {
          text: "30s",
          value: 1,
        },
        {
          text: "40s",
          value: 2,
        },
        {
          text: "50s",
          value: 3,
        },
        {
          text: "60s",
          value: 4,
        },
        {
          text: "70+",
          value: 5,
        },
      ],
    },
  },
  {
    route: "/onboarding/AboutYouRoutine",
    type: 1,
    data: {
      eventFillName: "current lifestyle",
      nextRoute: "/onboarding/AboutYouD2",
      questionNum: 4,
      totalQuestion: 5,
      questionBlock: 0,
      dependOn: ["/onboarding/AboutYouGender", "/onboarding/AboutYouAge"],
      questions: [
        [
          "Women in their 20s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "Women in their 30s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "Women in their 40s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "Women in their 50s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "Women in their 60s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "Women in their 70+ who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
        ],
        [
          "Men in their 20s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "Men in their 30s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "Men in their 40s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "Men in their 50s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "Men in their 60s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "Men in their 70+ who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
        ],
        [
          "People in their 20s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "People in their 30s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "People in their 40s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "People in their 50s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "People in their 60s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "People in their 70+ who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
        ],
        [
          "People in their 20s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "People in their 30s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "People in their 40s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "People in their 50s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "People in their 60s who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
          "People in their 70+ who want to improve their sleep need a slightly different strategy depending on their current lifestyle. Which best describes you?",
        ],
      ],

      answers: [
        {
          text: "Evening routine needs a lot of work",
          value: 0,
        },
        {
          text: "I have some healthy habits",
          value: 1,
        },
        {
          text: "I have a mindful evening routine",
          value: 2,
        },
      ],
    },
  },
  {
    route: "/onboarding/aboutYouD2",
    type: 2,
    data: {
      eventFillName: "lifestyle result",
      nextRoute: "/onboarding/AboutYouActivity",
      title: [
        "We’ve got you covered!",
        "You’re probably doing better than you think!",
        "Wonderful!",
      ],
      dependOn: {
        title: "/onboarding/AboutYouRoutine",
        depend: "value",
      },
      textHtml: [
        {
          __html:
            "We’ll start small, realistic goals.<br/> (Those small changes add up!)",
        },
        {
          __html:
            "We’ll help you identify what’s working and how to stick with it!",
        },
        {
          __html:
            "We’ll dig into what’s working (and what isn’t) and go from there",
        },
      ],
    },
  },
  {
    route: "/onboarding/AboutYouActivity",
    type: 1,
    data: {
      eventFillName: "day activity",
      nextRoute: "/onboarding/AboutYouD4",
      questionNum: 5,
      totalQuestion: 5,
      questionBlock: 0,
      question: "How active are you during the day?",
      answers: [
        {
          text: "Not much",
          value: 0,
        },
        {
          text: "Moderately active",
          value: 1,
        },
        {
          text: "Very active",
          value: 2,
        },
      ],
    },
  },
  {
    route: "/onboarding/aboutYouD4",
    type: 2,
    data: {
      eventFillName: "thanks for share",
      nextRoute: "/onboarding/AboutYouProof1",
      title: "Thanks for sharing",
      text: "We’re really glad you shared. Improving sleep is an important goal, but Journey’s mission is helping people get happier, whatever that is for them.",
    },
  },
  {
    route: "/onboarding/AboutYouProof1",
    type: 3,
    data: {
      pixelEvent: "Add To Cart",
      eventFillName: "pre-sleep stress",
      nextRoute: "/onboarding/SleepAndActivityQ1",
      questionNum: 6,
      totalQuestion: 5,
      questionBlock: 0,
      img: graph,
      dependOn: ["/onboarding/AboutYouGender", "/onboarding/AboutYouAge"],
      title: [
        [
          "Journey helped 54,325 women in their 20s feel better and sleep healthier",
          "Journey helped 54,325 women in their 30s feel better and sleep healthier",
          "Journey helped 54,325 women in their 40s feel better and sleep healthier",
          "Journey helped 54,325 women in their 50s feel better and sleep healthier",
          "Journey helped 54,325 women in their 60s feel better and sleep healthier",
          "Journey helped 54,325 women in their 70+ feel better and sleep healthier",
        ],
        [
          "Journey helped 54,325 men in their 20s feel better and sleep healthier",
          "Journey helped 54,325 men in their 30s feel better and sleep healthier",
          "Journey helped 54,325 men in their 40s feel better and sleep healthier",
          "Journey helped 54,325 men in their 50s feel better and sleep healthier",
          "Journey helped 54,325 men in their 60s feel better and sleep healthier",
          "Journey helped 54,325 men in their 70+ feel better and sleep healthier",
        ],
        [
          "Journey helped 54,325 people in their 20s feel better and sleep healthier",
          "Journey helped 54,325 people in their 30s feel better and sleep healthier",
          "Journey helped 54,325 people in their 40s feel better and sleep healthier",
          "Journey helped 54,325 people in their 50s feel better and sleep healthier",
          "Journey helped 54,325 people in their 60s feel better and sleep healthier",
          "Journey helped 54,325 people in their 70+ feel better and sleep healthier",
        ],
        [
          "Journey helped 54,325 people in their 20s feel better and sleep healthier",
          "Journey helped 54,325 people in their 30s feel better and sleep healthier",
          "Journey helped 54,325 people in their 40s feel better and sleep healthier",
          "Journey helped 54,325 people in their 50s feel better and sleep healthier",
          "Journey helped 54,325 people in their 60s feel better and sleep healthier",
          "Journey helped 54,325 people in their 70+ feel better and sleep healthier",
        ],
      ],
      text: "Pre-sleep stress levels depending on bedtime activity",
      subtext:
        "Based on CBT-I (Cognitive Behavioral Therapy) techniques, Journey effectively reduces stress and prevents repetitive thinking, helps you stay asleep longer.",
      loadingArray: [
        {
          finish: 32,
          timeout: 40,
        },
        {
          finish: 36,
          timeout: 160,
        },
        {
          finish: 68,
          timeout: 40,
        },
        {
          finish: 71,
          timeout: 160,
        },
        {
          finish: 91,
          timeout: 40,
        },
        {
          finish: 100,
          timeout: 160,
        },
      ],
      loadingTextArray: [
        {
          startPercent: 0,
          finishPercent: 50,
          text: "Connecting to database",
        },
        {
          startPercent: 51,
          finishPercent: 99,
          text: "Preliminary processing",
        },
      ],
    },
  },
  {
    route: "/onboarding/SleepAndActivityQ1",
    type: 1,
    data: {
      eventFillName: "trouble sleeping",
      nextRoute: "/onboarding/SleepAndActivityQ2",
      questionNum: 1,
      totalQuestion: 8,
      questionBlock: 1,
      question: "How often do you have trouble sleeping?",
      answers: [
        {
          text: "Occasionally",
          value: 0,
        },
        {
          text: "Frequently",
          value: 1,
        },
        {
          text: "Every night",
          value: 2,
        },
      ],
    },
  },
  {
    route: "/onboarding/SleepAndActivityQ2",
    type: 4,
    data: {
      eventFillName: "life events",
      nextRoute: "/onboarding/SleepAndActivityD1",
      questionNum: 2,
      totalQuestion: 8,
      questionBlock: 1,
      question:
        "Have any life events led to sleep problems in the last few years?",
      answers: [
        {
          text: "Marriage or relationship",
          value: 0,
        },
        {
          text: "Worries about future",
          value: 1,
        },
        {
          text: "Job",
          value: 2,
        },
        {
          text: "Family issues",
          value: 3,
        },
        {
          text: "Health issues",
          value: 4,
        },
        {
          text: "Stress",
          value: 5,
        },
        {
          text: "None of the above",
          value: 6,
        },
      ],
    },
  },
  {
    route: "/onboarding/SleepAndActivityD1",
    type: 2,
    data: {
      eventFillName: "life events changes",
      nextRoute: "/onboarding/SleepAndActivityQ3",
      title: "Big life changes often affect the quality of sleep",
      text: "It’s normal. The good news? You can always change your habits for the better.",
    },
  },
  {
    route: "/onboarding/SleepAndActivityQ3",
    type: 4,
    data: {
      eventFillName: "how it reveals",
      nextRoute: "/onboarding/SleepAndActivityProof1",
      questionNum: 3,
      totalQuestion: 8,
      questionBlock: 1,
      question: "How does stress reveal itself?",
      answers: [
        {
          text: "Insomnia",
          value: 0,
        },
        {
          text: "Restless sleep",
          value: 1,
        },
        {
          text: "Bad mood in the morning",
          value: 2,
        },
        {
          text: "Other",
          value: 3,
        },
      ],
    },
  },
  {
    route: "/onboarding/SleepAndActivityProof1",
    type: 5,
    data: {
      eventFillName: "science fact",
      nextRoute: "/onboarding/SleepAndActivityProof2",
      title: "Why weekend binge-sleeping fails or the “Yo-Yo” effect:",
      imgBig: graph1,
      imgSmall: alaska,
      text: [
        {
          __html:
            "<b>Alaska Sleep Clinic</b> reports weekend binge-sleeping creates a crash and burn lifestyle that disrupts the normal sleep REM cycle leading people to straight exhaustion.",
        },
        {
          __html:
            "Establishing <b>a healthy pattern</b> of sleep will help you repay your sleep debt and deal with the effects of sleep deprivation.",
        },
      ],
    },
  },
  {
    route: "/onboarding/SleepAndActivityProof2",
    type: 6,
    data: {
      eventFillName: "testimonial",
      nextRoute: "/onboarding/SleepAndActivityCoffee",
      title: "Sticking to a plan can be hard, but Journey makes it easy",
      dependOn: ["/onboarding/AboutYouGender"],
      imgBig: [women, men, women, women],
      comment:
        '"The Journey app is so helpful. It made my sleep schedule so much better. I am able to go to sleep so much faster and not lay awake looking at my ceiling in my bed. Thank you!"',
      name: ["Olivia, 60", "Greg, 54", "Olivia, 60", "Olivia, 60"],
      text: "People who use Journey notice improvement in their sleep just after a couple of days",
      buttonText: "Got it",
    },
  },
  {
    route: "/onboarding/SleepAndActivityCoffee",
    type: 1,
    data: {
      eventFillName: "caffeine",
      nextRoute: "/onboarding/SleepAndActivityDinner",
      title: "“I often consume caffeine in the evening”",
      questionNum: 4,
      totalQuestion: 8,
      questionBlock: 1,
      question: "Do you relate to the statement below:",
      answers: [
        {
          text: "Yes",
          value: 0,
        },
        {
          text: "No",
          value: 1,
        },
      ],
    },
  },
  {
    route: "/onboarding/SleepAndActivityDinner",
    type: 1,
    data: {
      eventFillName: "go to bed",
      nextRoute: "/onboarding/SleepAndActivityAfterMidnight",
      title: "“I go to bed in less than 2 hours after dinner”",
      questionNum: 5,
      totalQuestion: 8,
      questionBlock: 1,
      question: "Do you relate to the statement below:",
      answers: [
        {
          text: "Yes",
          value: 0,
        },
        {
          text: "No",
          value: 1,
        },
      ],
    },
  },
  {
    route: "/onboarding/SleepAndActivityAfterMidnight",
    type: 1,
    data: {
      eventFillName: "stay up late",
      nextRoute: "/onboarding/SleepAndActivityLessThanEightHours",
      title: "“I often stay up late and go to bed after midnight”",
      questionNum: 6,
      totalQuestion: 8,
      questionBlock: 1,
      question: "Do you relate to the statement below:",
      answers: [
        {
          text: "Yes",
          value: 0,
        },
        {
          text: "No",
          value: 1,
        },
      ],
    },
  },
  {
    route: "/onboarding/SleepAndActivityLessThanEightHours",
    type: 1,
    data: {
      eventFillName: "sleep less eight",
      nextRoute: "/onboarding/SleepAndActivityExtraMotivation",
      title: "“I often sleep less than 8 hours a night”",
      questionNum: 7,
      totalQuestion: 8,
      questionBlock: 1,
      question: "Do you relate to the statement below:",
      answers: [
        {
          text: "Yes",
          value: 0,
        },
        {
          text: "No",
          value: 1,
        },
      ],
    },
  },
  {
    route: "/onboarding/SleepAndActivityExtraMotivation",
    type: 1,
    data: {
      eventFillName: "extra motivation",
      nextRoute: "/onboarding/SleepAndActivityD2",
      title: "“I need some extra motivation to go to bed on time”",
      questionNum: 9,
      totalQuestion: 8,
      questionBlock: 1,
      question: "Do you relate to the statement below:",
      answers: [
        {
          text: "Yes",
          value: 0,
        },
        {
          text: "No",
          value: 1,
        },
      ],
    },
  },
  {
    route: "/onboarding/SleepAndActivityD2",
    type: 2,
    data: {
      pixelEvent: "Lead",
      eventFillName: "quiz result",
      nextRoute: "/onboarding/SleepAndActivityLoader",
      questionNum: 2,
      totalQuestion: 5,
      questionBlock: 0,
      dependKeys: [
        "/onboarding/SleepAndActivityExtraMotivation",
        "/onboarding/SleepAndActivityLessThanEightHours",
        "/onboarding/SleepAndActivityCoffee",
        "/onboarding/SleepAndActivityDinner",
        "/onboarding/SleepAndActivityAfterMidnight",
      ],
      title: ["No one is perfect", "You are on the right track!"],
      text: [
        "Journey is here to give you motivation when needed and forgiveness when you start blaming yourself.",
        "You are already doing a great job. Together with Journey you could achieve your goals faster and secure the results",
      ],
    },
  },
  {
    route: "/onboarding/SleepAndActivityLoader",
    type: 7,
    data: {
      nextRoute: "/onboarding/PersonalizationD1",
      title: [
        "Our program consists of sound-based sessions",
        "Exclusive sleep music and meditations",
        "Unique sleep stories to reduce anxiety and stress",
        "We’re going to change your sleep routine for the better",
        "Personal sleep coach will guide you and help change your sleep habits",
        "Our plan is designed as mindful alternative to TV and social media",
        "Learn strategies for better sleep with a tailor-made course",
      ],
      needBeImgIndexes: [2, 4, 6],
      bg: [bg1, bg2, bg3, bg4, bg5, bg6, bg7],
      bgM: [bg1M, bg2M, bg3M, bg4M, bg5M, bg6M, bg7M],
    },
  },
  {
    route: "/onboarding/PersonalizationD1",
    type: 2,
    data: {
      eventFillName: "program intro",
      nextRoute: "/onboarding/PersonalizationColors1",
      icon: logoLittle,
      title: "Almost there!",
      text: "Let’s customize your plan",
      text2:
        "Your responses will help us tailor the Journey experience around your personality and exclusively for your goals.",
    },
  },
  {
    route: "/onboarding/PersonalizationColors1",
    type: 8,
    data: {
      eventFillName: "sounds type",
      nextRoute: "/onboarding/PersonalizationColors2",
      questionNum: 1,
      totalQuestion: 9,
      questionBlock: 2,
      question: "What type of sounds do you like more: ",
      text: "Journey will tailor your Sleep Plan sounds settings",
      audioIndex: 0,
      answers: [
        {
          img: ans1,
          text: "Birds",
          value: 0,
        },
        {
          img: ans2,
          text: "Rain",
          value: 1,
        },
      ],
    },
  },
  {
    route: "/onboarding/PersonalizationColors2",
    type: 8,
    data: {
      eventFillName: "sounds type",
      nextRoute: "/onboarding/PersonalizationColors3",
      questionNum: 2,
      totalQuestion: 9,
      questionBlock: 2,
      question: "What type of sounds do you like more: ",
      text: "Journey will tailor your Sleep Plan sounds settings",
      audioIndex: 1,
      answers: [
        {
          img: ans3,
          text: "Thunderstorm",
          value: 2,
        },
        {
          img: ans4,
          text: "White noise",
          value: 3,
        },
      ],
    },
  },
  {
    route: "/onboarding/PersonalizationColors3",
    type: 8,
    data: {
      eventFillName: "sounds type",
      nextRoute: "/onboarding/PersonalizationColors4",
      questionNum: 3,
      totalQuestion: 9,
      questionBlock: 2,
      question: "What type of sounds do you like more: ",
      text: "Journey will tailor your Sleep Plan sounds settings",
      audioIndex: 2,
      answers: [
        {
          img: ans5,
          text: "Ocean",
          value: 4,
        },
        {
          img: ans6,
          text: "Forest",
          value: 5,
        },
      ],
    },
  },
  {
    route: "/onboarding/PersonalizationColors4",
    type: 8,
    data: {
      eventFillName: "sounds type",
      nextRoute: "/onboarding/PersonalizationProof1",
      // nextRoute: "/onboarding/pre-paywall",
      questionNum: 4,
      totalQuestion: 9,
      questionBlock: 2,
      question: "What type of sounds do you like more: ",
      text: "Journey will tailor your Sleep Plan sounds settings",
      audioIndex: 3,
      answers: [
        {
          img: ans7,
          text: "Meditation",
          value: 6,
        },
        {
          img: ans8,
          text: "Religion",
          value: 7,
        },
      ],
    },
  },
  {
    route: "/onboarding/PersonalizationProof1",
    type: 3,
    data: {
      eventFillName: "program based",
      nextRoute: "/onboarding/PersonalizationNarrative",
      questionNum: 5,
      totalQuestion: 9,
      questionBlock: 2,
      img: graph2,
      subtext:
        "Our program is based on techniques from Cognitive Behavioural Therapy (CBT). CBT has been proven to be effective at reducing stress and anxiety in research funded by the National Institute of Mental Health",
      littleText:
        "Hoffmann, S.G., Asnaani, A., Vonk, I.J.et al. The Efficacy of Cognitive Behavioural Therapy a Review of Meta-analyses. Cog Ther Res 36, 427-440(2012)",
    },
  },
  {
    route: "/onboarding/PersonalizationNarrative",
    type: 2,
    data: {
      eventFillName: "preferable sounds",
      audioEventFillName: "sleep_music_play",
      nextRoute: "/onboarding/PersonalizationLoader",
      questionNum: 6,
      totalQuestion: 9,
      questionBlock: 2,
      title: "Your personalized sleep sounds",
      titleRemoteFalse:
        "Your personalized sleep sounds are waiting for you in the app",
      text: "Preview one of our most popular Journey sleep sounds below for free and see how Journey can help you fall asleep tonight.",
      textRemoteFalse:
        "More than 500 Journey sleep stories and sounds can help you fall asleep tonight.",
      audioDepend: true,
      remoteConfigKeyDepending: "sleepSoundsEnabled",
      audioArray: [
        {
          src: birdsAudio,
          img: birdsPreview,
          id: 0,
          title: "Nature",
          name: "Forest Birds",
        },
        {
          src: rainAudio,
          img: rainPreview,
          id: 1,
          title: "Nature",
          name: "Light Rain",
        },
        {
          src: thunderstormAudio,
          img: thunderstormPreview,
          id: 2,
          title: "Nature",
          name: "Thunderstorm",
        },
        {
          src: whiteNoiseAudio,
          img: whiteNoisePreview,
          id: 3,
          title: "Nature",
          name: "White Noise",
        },
        {
          src: oceanAudio,
          img: oceanPreview,
          id: 4,
          title: "Nature",
          name: "Ocean",
        },
        {
          src: forestAudio,
          img: forestPreview,
          id: 5,
          title: "Nature",
          name: "Forest",
        },
        {
          src: meditationAudio,
          img: meditationPreview,
          id: 6,
          title: "MEDITATION",
          name: "Mind Relaxation",
        },
        {
          src: religionAudio,
          img: religionPreview,
          id: 7,
          title: "MEDITATION",
          name: "Gods Blessing",
        },
      ],
    },
  },
  // {
  //   route: "/onboarding/PersonalizationNarrative",
  //   type: 4,
  //   data: {
  //     eventFillName: "preferable sounds",
  //     nextRoute: "/onboarding/PersonalizationLoader",
  //     questionNum: 6,
  //     totalQuestion: 9,
  //     questionBlock: 2,
  //     question: "Choose preferable sounds:",
  //     text: "We’ll customize your sleepscape",
  //     answers: [
  //       {
  //         text: "Rain",
  //         value: 0,
  //       },
  //       {
  //         text: "Thunderstorm",
  //         value: 1,
  //       },
  //       {
  //         text: "Birds",
  //         value: 2,
  //       },
  //       {
  //         text: "Meditation",
  //         value: 3,
  //       },
  //       {
  //         text: "Classic music",
  //         value: 4,
  //       },
  //       {
  //         text: "Bible",
  //         value: 5,
  //       },
  //     ],
  //   },
  // },
  {
    route: "/onboarding/PersonalizationLoader",
    type: 9,
    data: {
      eventFillName: "analyzing answers",
      nextRoute: "/onboarding/PersonalizationD2",
      title: "Analyzing your answers...",
      subtitle: "Trusted by over 149,569 people",
      loaders: [
        {
          bgColor: "#C5CAFF",
          color: "#6070FF",
          text: "Tailoring Sleep Sounds",
          stopPercent: 75,
        },
        {
          bgColor: "#FFDDA9",
          color: orangeColor,
          text: "Adjusting Personal Digital Sleep Coach",
          stopPercent: 90,
        },
        {
          bgColor: "#B9E3C4",

          color: greenColor,
          text: "Adapting Personal Sleep Course",
          stopPercent: 55,
        },
        {
          bgColor: "#F9C2B7",
          color: "#F16B50",
          text: "Personalizing Your Sleep Plan",
          stopPercent: 101,
        },
      ],
      popups: [
        {
          title: "Have you tried sound therapy before?",
          eventFillName: "sound therapy",
        },
        {
          title: "Have you ever used sleep coaching before?",
          eventFillName: "daydream",
        },
        {
          title: "Have you used mobile apps to improve your sleep before?",
          eventFillName: "noise in ears",
        },
        // {
        //   title: "Do you read to unwind before sleep?",
        //   eventFillName: "reading",
        // },
      ],
      comments: [
        {
          text: "I have a hectic mind, and Journey brings me to a more quiet place in the evening",
          name: "Farley",
        },
        {
          text: "Absolutely excellent variety of music and sounds. Keeps my interest up every night.",
          name: "Dino",
        },
        {
          text: "Digital coach is just like a friend. Asking me how I slept and giving suitable advice.",
          name: "Nancy",
        },
        {
          text: "It significantly helped me. I have a better sleep and I get to bed faster.",
          name: "Heidi",
        },
      ],
    },
  },
  {
    route: "/onboarding/PersonalizationD2",
    type: 2,
    data: {
      eventFillName: "goal info",
      pixelEvent: "Customize product",
      nextRoute: "/onboarding/PersonalizationGoal",
      title: "Set up your goal",
      texts: [
        "A goal without a plan is just a wish.",
        "Did you know... Setting small goals allows for more frequent wins.",
        "Reaching these goals keeps you motivated.",
        "Staying motivated helps you crush more goals. So let’s do this...",
      ],
      buttonText: "Set my first goal",
    },
  },
  {
    route: "/onboarding/PersonalizationGoal",
    type: 4,
    data: {
      eventFillName: "setup goal",
      withOutProgress: true,
      nextRoute: "/onboarding/create-account",
      question:
        "In addition to your sleep improvement goal, what sleep related goals you would like to achieve with your program?",
      answers: [
        {
          text: "Build a healthy sleep routine",
          value: 0,
        },
        {
          text: "Be more productive at work",
          value: 1,
        },
        {
          text: "Wake up early",
          value: 2,
        },
        {
          text: "Feel healthier",
          value: 3,
        },
        {
          text: "Other",
          value: 4,
        },
      ],
    },
  },
  {
    route: "/onboarding/create-account",
    type: 10,
    data: {
      eventFillName: "personalized sleep plan",
      questionNum: 7,
      totalQuestion: 9,
      questionBlock: 2,
      title: "Your personalized sleep plan #LN-43443 is ready",
      text: "Enter your email to receive your personal sleepscape plan",
      bottomText:
        "Your information is 100% secure. By submitting your email address, you may also receive emails from Journey about new offers, features and updates. You may unsubscribe at any time.",
      nextRoute: [
        "/onboarding/subscription",
        "/onboarding/paywall",
        // "/onboarding/cost",
        "/onboarding/pre-paywall",
      ],
      specialProgressText: "Almost there",
    },
  },
  {
    route: "/onboarding/pre-paywall",
    type: 14,
    data: {
      eventFillName: "personalized sleep plan",
      nextRoute: ["/onboarding/cost", "/onboarding/paywall"],
    },
  },
  {
    route: "/onboarding/cost",
    type: 11,
    data: {
      text: [
        "Money shouldn't get in the way of finding a Sleep Plan that finally works. Choose a price that you believe you can afford to try Journey for 7 days.",
        "It normally costs us $17.41 to compensate our employees and sleep experts for the trial, but please choose the amount you are comfortable with.",
      ],
      title: "Try Journey for 7 days",
      orangeText:
        "It normally costs us $17.41 to compensate our employees for the trial, but please choose the amount you are comfortable with.",
      bottomText: "You won’t be charged at this step.",
      nextRoute: "/onboarding/paywall",
      answers: [
        {
          sum: "$0.99",
          value: 0.99,
        },
        {
          sum: "$5",
          value: 5,
        },
        {
          sum: "$10",
          text: "Most Popular",
          value: 10,
        },
        {
          sum: "$17.41",
          text: "Cost to pay our team",
          value: 17.41,
        },
      ],
    },
  },
  {
    route: "/onboarding/subscription",
    type: 12,
  },
  // paywall
  {
    route: "/onboarding/paywall",
    type: 13,
    // data: {
    //   eventFillName: "personalized sleep plan",
    //   questionNum: 7,
    //   totalQuestion: 9,
    //   questionBlock: 2,
    //   title: "Your personalized sleep plan #LN-43443 is ready",
    //   text: "Enter your email to receive your personal sleepscape plan",
    //   bottomText:
    //     "Your information is 100% secure. By submitting your email address, you may also receive emails from Journey about new offers, features and updates. You may unsubscribe at any time.",
    //   nextRoute: "/onboarding/subscription",
    //   specialProgressText: "Almost there",
    // },
  },
];
//END PAGES

//offer What You Get
export const offerWhatYouGet = [
  {
    id: 0,
    img: whatYourGetItem1,
    title: 'Sleep Stories'
  },
  {
    id: 1,
    img: whatYourGetItem2,
    title: 'Bible Stories'
  },
  {
    id: 2,
    img: whatYourGetItem3,
    title: 'ASMR'
  },
  {
    id: 3,
    img: whatYourGetItem4,
    title: 'Soothing Video'
  },
  {
    id: 4,
    img: whatYourGetItem5,
    title: 'Meditations'
  },
  {
    id: 5,
    img: whatYourGetItem6,
    title: 'Nature Sounds'
  },
  {
    id: 6,
    img: whatYourGetItem7,
    title: 'Instrumental music'
  },
  {
    id: 7,
    img: whatYourGetItem8,
    title: 'Ambient content'
  }
]

export const offerSubscriptionText = `Your subscription lasts until ${moment()
  .add(3, "month")
  .format("hh:mm A, MMMM DD, YYYY ")}. If you don’t cancel, Journey will automatically continue your membership (currently $29.99) on a quarterly basis until your cancel. You can cancel your subscriptions anytime on your Subscription Management page.
`
